
import { create } from "zustand";
import { deleteQuery, getQueryFunction } from "../api/query";

export const useQueryStore = create((set, get) => ({
    loading: true,
    banner: null,
    query: [],
    getQuery: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true });
            const res = await getQueryFunction(pageNumber, pageSize, search, field);
            set({
                loading: false,
                query: res?.ref
            });
            return res;
        } catch (error) {
            console.log("Error in query:", error);
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    deleteQuery: async (id) => {
        try {
            set({ loading: true })
            const res = await deleteQuery(id)
            if (res) {
                const currentquery = get().query || [];
                const updatedquery = currentquery.filter((ele) => ele._id !== id);
                set({ loading: false, query: updatedquery });
            }
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
}));
